import aiPng from '../assets/file-icons/aiPng.png';
import excelPng from '../assets/file-icons/excelPng.png';
import imagePng from '../assets/file-icons/imagePng.png';
import pdfPng from '../assets/file-icons/pdfPng.png';
import pptPng from '../assets/file-icons/pptPng.png';
import textPng from '../assets/file-icons/textPng.png';
import videoPng from '../assets/file-icons/videoPng.png';
import audioPng from '../assets/file-icons/audioPng.png';
import wordPng from '../assets/file-icons/wordPng.png';
import zipPng from '../assets/file-icons/zipPng.png';
import codePng from '../assets/file-icons/codePng.png';

export const fileIconMap: Record<string, string> = {
  'ai': aiPng,
  'excel': excelPng,
  'image': imagePng,
  'pdf': pdfPng,
  'ppt': pptPng,
  'text': textPng,
  'video': videoPng,
  'audio': audioPng,
  'word': wordPng,
  'zip': zipPng,
  'code': codePng
};